import React from 'react';

import {
  Drupal_ParagraphFeatureGridItem,
  Drupal_ParagraphSeoImage
} from '../../../generated/graphql';
import Link from '../../link/link';
import './feature-grid-item.scss';

interface Props {
  item: Drupal_ParagraphFeatureGridItem;
  buttonText: string;
  hasBorder?: boolean;
}

const FeatureGridItem = ({ item, buttonText, hasBorder = true }: Props) => {
  const image =
    item.fieldFeatureImage &&
    (item.fieldFeatureImage.entity as Drupal_ParagraphSeoImage);
  return (
    <div
      className={`feature-grid-item ${
        hasBorder ? 'feature-grid-item--no-border' : ''
      }`}
    >
      {image && image.fieldImageLink && (
        <img
          className="feature-grid-item__image"
          src={image.fieldImageLink}
          alt={image.fieldAltText!}
        />
      )}
      <h3 className="feature-grid-item__heading">{item.fieldFeatureTitle}</h3>
      <p className="feature-grid-item__content">
        {item.fieldFeatureDescription}
      </p>
      {item.fieldFeatureLink && (
        <Link
          secondary
          hasArrow
          to={item.fieldFeatureLink}
          className="feature-grid-item__link"
        >
          {buttonText}
        </Link>
      )}
    </div>
  );
};

export default FeatureGridItem;
